export default __webpack_public_path__ + "static/media/genuine-kia.8ed3a2a7.jpg";